import createAxios from 'App/utils/createAxios';
import URLBuilder from './UrlBuilderService';

const icd10Request = createAxios({});

function search(query, limit) {
    const url = URLBuilder.build('searchIcd10', {
        therapy: '',
        search: '',
        'auto-complete': '',
        icd10: '',
    });
    return icd10Request.get(url, {
        params: {
            query,
            ...(limit ? { limit } : {}),
        },
    });
}

export { search };
